import styled, { css } from "styled-components";
import { Flex } from "../Flex";
export const SearchBoxContent = styled(Flex)(({ theme: { colors: { searchBoxColors, inputColors }, shadows: { searchBox: { contentShadow }, }, borders, }, showSearchButton, showSearchIcon, width, }) => {
    const content = `
    display: block;
    position: relative;
    border: ${borders[1]};
    border-color: ${inputColors.inputBorder};
    border-radius: 4px;
    border-top-right-radius: ${showSearchButton ? "0px" : "4px"};
    border-bottom-right-radius: ${showSearchButton ? "0px" : "4px"};
    background-color: ${inputColors.inputBackground};
    width: ${width || "100%"};
    padding: 0 6px;
    overflow: hidden;
    &.active {
      box-shadow: ${contentShadow}; // box-shadow for accessibility
      border-color: ${inputColors.inputFocusBorder};
    }
    &:hover {
      cursor: text;
    }
    &.disabled {
      background-color: ${inputColors.inputDisabledBackground};
      cursor: auto;
    }
  `;
    const contentWithSearchIcon = `${content}
    .searchBoxFilter:first-child {
      margin-left: 30px;
    }
    input:first-child {
      margin-left: 30px;
    }
    &::before {
      content: "\\e003"; // magnifying glass
      color: ${searchBoxColors.magnifyingGlass};
      position: absolute;
      top: 8px;
      left: 11px;
      font-family: "Glyphicons Halflings";
    }
  `;
    return css `
      ${showSearchIcon ? contentWithSearchIcon : content}
    `;
});
